import React from "react";
import "./App.css";
import Header from "./components/header/header";

function App() {
  return (
    <div className="container">
      <Header />
    </div>
  );
}

export default App;
